import { IDoctorForDocument, ITransmittable } from '@alberta/konexi-shared';
import { IPrescriptionRequest } from '@alberta/konexi-shared/dist/prescription/prescription-request';
import { removeTime } from '@common/tracking/tracker';
import { BaseViewModel } from 'src/app/common/viewmodel/base-view-model';
import { PrescriptionViewModel } from './prescription-view-model';
export class PrescriptionRequestViewModel extends BaseViewModel implements IPrescriptionRequest {
  attachments: {
    _id: string;
    filename: string;
    contentType: string;
  }[];
  patientId: string;
  regionId: string;
  singleOrderId: string;
  templateId: string;
  correspondenceType: ITransmittable['correspondenceType'];
  reminderLevel?: number;
  to: string;
  salutationCode?: string;
  doctor: IDoctorForDocument;
  patient: {
    customerNumber: string;
    name: string;
    additionalName: string;
    address: string;
    postalCode: string;
    city: string;
    birthday: string;
  };
  payer: {
    name: string;
    numberOfInsured: string;
  };
  bodyTexts: string[];
  prescriptions: PrescriptionViewModel[];
  additionalProperties: any;
  status: ITransmittable['status'];
  retry: number;
  faxProvider: string;
  faxProviderId: string;
  lastError: string;
  mimeType: string;
  fileUrl: string;
  fileName: string;
  subject: string;
  body: string;
  history: {
    status: string;
    lastError?: string;
    retry?: number;
    timestamp: Date;
  }[];
  diagnose: string;
  @removeTime()
  startDate: Date;
  @removeTime()
  endDate: Date;
  replyTo: string;
}
